import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutateSeniority = () => {
  const searchedKey = getCacheKey('/seniorities');
  if (searchedKey) {
    mutate(searchedKey);
  }
};
